<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div class="text-right mb-2">
          <b-button align="right" variant="primary" @click="create()">Create</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card :header="caption">
          <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
            <template slot="action" slot-scope="data">
              <b-button type="button" size="sm" variant="primary" @click="update(data.item.id)">Edit</b-button>
            </template>
          </b-table>
          <nav>
            <b-pagination align="right" :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
        </b-card>        
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'accounts',
    props: {
      caption: {
        type: String,
        default: '<i class="fa fa-align-justify"></i> Accounts'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: true
      },
      small: {
        type: Boolean,
        default: true
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        errors: [],
        fields: [
          {key: 'name'},
          {key: 'address'},
          {key: 'timezone'},
          {key: 'status'},
          {key: 'action'}
        ],
        currentPage: 1,
        perPage: 10,
        totalRows: 0
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      getBadge (status) {
        return status === 'Active' ? 'success'
          : status === 'Inactive' ? 'secondary'
            : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
      },
      getRowCount (items) {
        return items.length
      },
      getItems () {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.headers.common['Accept'] = 'application/json'
        let accessToken = localStorage.getItem('access_token')

        if (accessToken !== null && accessToken !== '') {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
        }

        let uri = window.apiUri + 'accounts'
        axios.get(uri)
          .then(response => {
            // JSON responses are automatically parsed.
            this.items = response.data.data
          })
          .catch(error => {
            // Wu oh! Something went wrong
            console.log(error.response.data)
            this.errors.push(error.response.data)
          })
      },
      create () {
        this.$router.push('/accounts/create')
      },
      update (id) {
        this.$router.push('/accounts/edit/' + id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Accounts.vue